import { AdminContext, AdminUI, Resource } from 'react-admin';
import LogsDataProvider from './LogsDataProvider';
import LogListWithProvider from './LogsListWithProvider';
import { LogShow } from './Logs';

const LogsResource = () => (
  <AdminContext dataProvider={LogsDataProvider}>
    <AdminUI>
      <Resource name="logs" list={LogListWithProvider} show={LogShow} />
    </AdminUI>
  </AdminContext>
);

export default LogsResource;